import { Entry } from '../Entry'

export function Entry20220128() {
  return (
    <Entry title="27/01/2022 - v3.0.0-beta-14.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12449/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
